import {classToPlain, Exclude, Expose, plainToClass, Type} from "class-transformer";
import * as t from "io-ts";
import "reflect-metadata";
import {validateJSON} from "../web/validation";
import {ContainerStatusArrayCodec, ContainerStatusEntity} from "./container-status";

export const SiteStatusValidator = t.intersection([
  t.type({
    siteId: t.string,
    siteName: t.string,
    containerStatuses: ContainerStatusArrayCodec,
  }),
  t.partial({}),
]);

export const SiteStatusArrayValidator = t.array(SiteStatusValidator);

export type SiteStatus = t.TypeOf<typeof SiteStatusValidator>;
export type SiteStatusArray = t.TypeOf<typeof SiteStatusArrayValidator>;

/**
 * A container.
 */
@Exclude()
export class SiteStatusEntity {
  @Expose() siteId!: string;
  @Expose() siteName!: string;
  @Expose()
  @Type(() => ContainerStatusEntity)
  containerStatuses: ContainerStatusEntity[] = [];
  @Expose() offset!: number;

  /**
   * Constructor for SiteStatusEntity.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  /**
   * Create a SiteStatusEntity from a SiteStatus type value.
   *
   * @param containerLevel The container level type value.
   */
  static from(containerLevel: SiteStatus): SiteStatusEntity {
    const entity: SiteStatusEntity = plainToClass(
      SiteStatusEntity,
      containerLevel,
      {
        excludeExtraneousValues: true,
      }
    );
    return entity;
  }

  /**
   * Deserializes the SiteStatusEntity to a SiteStatus type value.
   * If validation fails, the promise will be rejected.
   */
  toTypeValue(): Promise<SiteStatus> {
    const object = classToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(SiteStatusValidator, object);
  }
}
